<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.the-analysis-section
    t-section
      template(v-if="lng === 'ua'")
        t-h2 АНАЛІЗ РЕЗУЛЬТАТУ ІНДЕКСУ СПРИЙНЯТТЯ КОРУПЦІЇ-2018 УКРАЇНИ
        .block
          +e.P.text Україна здобула 32 бали (на два більше ніж у 2017) та піднялася з 130 на 120 місце в глобальному рейтингу “Індекс сприйняття корупції” за результатами 2018 року.

          +e.P.text Аналіз досліджень, на основі яких розраховувався Індекс, свідчить про певне зменшення рівня корупції у відносинах між бізнесом та державними структурами. Цьому могли сприяти запровадження автоматичного відшкодування Податку на додану вартість, регулярна робота інституту бізнес-омбудсмена, функціонування електронних систем ProZorro та ProZorro. Продажі.

          +e.P.text Відновлення довіри до системи правосуддя залишається ключовим викликом, за оцінкою бізнесу.

          +e.P.text Ріст показників Індексу сприйняття корупції України за 2018 рік стримали і масові випадки тиску та нападів на активістів і журналістів, що працюють в сфері протидії корупції.

          +e.P.text Показник України досі гірший ніж у країн сусідів: Польща —60, Румунія — 47, Угорщина — 46, Білорусь — 44, Молдова — 33.

        .block
          t-h3 Аналіз виконання рекомендацій Трансперенсі Інтерненшл Україна на 2018 рік
        .block
          t-h3(left) Частково реалізовано:

          +e.P.text Ухвалено закон про Вищий антикорупційний суд, який в цілому відповідає рекомендаціям Венеціанської комісії і передбачає ключову роль міжнародних експертів у доборі суддів. Запуск перенесено на 2019 рік.

          +e.P.text Систему ProZorro.Продажі почали використовувати для малої приватизації, оренди комунальної нерухомості та вагонів “Укрзалізниці”.

        .block
          t-h3(left) Проігноровані рекомендації:

          +e.P.text Роль громадськості у процесі перевірки кандидатів на посади суддів не підвищилася. Вища кваліфікаційна комісія суддів ігнорувала висновки Громадської рада доброчесності.

          +e.P.text Не було посилено повноважень Національного антикорупційного бюро України. Детективи НАБУ не отримали права на власну “прослушку”. Зміни до законодавства ускладнили проведення експертиз в кримінальних провадженнях.

          +e.P.text Загострення неконструктивного публічного протистояння між правоохоронними органами. Підірвана довіра до одного з ключових елементів антикорупційної інфраструктури - Спеціалізованої антикорупційної прокуратури.

          +e.P.text Тиск на активістів та журналістів посилився. Страшний приклад цієї тенденції - вбивство Катерини Гандзюк.

          +e.P.text Національне агенство з питань запобігання корупції не перезапущено.

          +e.P.text Автоматична перевірка електронних декларацій у 2018 здійснювалася без доступу до всіх державних реєстрів. НАЗК не стало технічним адміністратором реєстру е-декларацій. Тендер на аудит його діяльності було проведено з порушенням закону.

          +e.P.text Служба безпеки України та Національна поліція не позбулися функції боротьби з економічними злочинами. Тиск з боку силовиків на бізнес залишався вагомим. Служби фінансових розслідувань не створено.

      template(v-if="lng === 'en'")
        t-h2 Analysis of Ukraine’s 2018 CPI Score
        .block
          +e.P.text Ukraine received 32 points (2 more than in 2017) and ranked 120th in the 2018 global index, vs. 130th place in 2017.

          +e.P.text According to the research used as the basis for the Index score, there has been a certain reduction of corruption levels in the relations between businesses and public authorities. Automated VAT refunds, regular work of the business ombudsman and functioning of the electronic systems ProZorro and ProZorro.Sale may have all contributed to this fact.

          +e.P.text Rebuilding the credibility of the justice system remains a key challenge, according to business.

          +e.P.text The growth of Ukraine’s Corruption Perception Index score in 2018 was hampered by numerous cases of pressure and attacks against anti-corruption activists and journalists.

          +e.P.text Ukraine is still behind its neighbors in CPI: Poland got 60 points, Romania - 47, Hungary - 46, Belarus - 44, Moldova - 33.

        .block
          t-h3 Fulfillment Analysis of 2018 Transparency International Ukraine’s Recommendations

        .block
          t-h3(left) Partially implemented:

          +e.P.text The law on the High Anti-Corruption Court was adopted, generally consistent with the recommendations of the Venice Commission: it stipulates the crucial role of international experts in the selection of judges. The beginning of operation was postponed to 2019.

          +e.P.text The ProZorro.Sale system is now used for small-scale privatization, lease of municipal property and lease of Ukrzaliznytsia train cars.

        .block
          t-h3(left) Disregarded recommendations:

          +e.P.text The public was not given more authority in the process of potential judge verification. The High Qualification Commission of Judges disregarded the conclusions of the Public Integrity Council.

          +e.P.text The powers of the National Anti-Corruption Bureau did not increase either. NABU detectives were not yet granted the right to independent wiretapping. Legislative changes further complicated forensic reviews in criminal proceedings.

          +e.P.text Counterproductive public conflict between law enforcement agencies aggravated. Credibility of a crucial element of the anti-corruption infrastructure - the Specialized Anti-Corruption Prosecutor’s Office - was undermined.

          +e.P.text Pressure against activists and journalists intensified. A remarkable and frightening example of this tendency was the murder of activist Kateryna Handziuk.

          +e.P.text The National Agency for Corruption Prevention is yet to be rebooted.

          +e.P.text In 2018, the automatic verification of electronic declarations took place without access to all state registers. The NACP did not become the technical administrator of the e-declarations register. The tender for the Agency’s audit was held with legislative violations.

          +e.P.text The Security Service of Ukraine and the National Police retained the function of economic crime prevention. Law enforcement bodies continued to put business under significant pressure. Financial Investigation Service was not created.
      .block
        youtube(:video-id="videoId")
</template>

<script>
import { mapGetters } from 'vuex';

import TSection from '@/components/TSection/TSection';
import TH2 from '@/components/TH2/TH2';
import TH3 from '@/components/TH3/TH3';

export default {
  name: 'the-analysis-section',

  computed: {
    videoId() {
      return this.$youtube.getIdFromURL('https://youtu.be/OIS0-M0wUOI');
    },

    ...mapGetters({
      lng: 'lng',
    }),
  },

  components: {
    TSection,
    TH2,
    TH3,
  },
};
</script>

<style lang="scss">
@import '../../scss/styles';

.the-analysis-section {
  &__text {
    color: #000;
    font-weight: 100;
    text-align: left;
    font-size: 14px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/TheAnalysisSection/TheAnalysisSection.vue